import { DEFAULT_LANG } from "@/lib/constants";
import { getNavServicesMegaColumns } from "@/lib/cc-nav-services-mega";
import { getNavResourcesIndustriesMegaColumn } from "@/lib/cc-nav-resources-mega";
import { buildLocalizedPath } from "@/lib/i18n/paths";
import { toSiteLocale } from "@/lib/i18n/config";
import type { Lang } from "@/lib/types";

/** Footer service columns — mega menu data, omitting columns with no published sub-links. */
export function getSiteFooterServiceMegaColumns(lang: Lang = DEFAULT_LANG) {
  const columns = getNavServicesMegaColumns(lang);
  return columns.filter((column) => column.links.length > 0);
}

/** Footer Industries / Branscher column — same data as the resources mega menu. */
export function getSiteFooterIndustriesMegaColumn(lang: Lang = DEFAULT_LANG) {
  const column = getNavResourcesIndustriesMegaColumn(lang);
  if (!column) {
    return null;
  }
  if (column.links.length === 0) {
    return null;
  }
  return column;
}

/** Navbar / mobile menu CTA href (main nav link row uses {@link getSiteNavContactLink}). */
export function getSiteNavCtaHref(lang: Lang = DEFAULT_LANG): string {
  const locale = toSiteLocale(lang);
  return buildLocalizedPath({ locale, customPath: "contact" });
}

